module.exports = __webpack_public_path__ + "static/3d-7f74fb4b2445800720d92ae04c0ca80f.jpg";